import { styled } from "styled-components";

export const PersonalColorReviews = styled.span`
  font-size: 24px;
`;
